const PageContainer = ({ children }) => {
  return (
    <div className="flex flex-col h-screen select-none">
      <div className={"flex-1 h-full"}>{children}</div>
    </div>
  );
};

export default PageContainer;
